import { connect } from 'react-redux'
import Enums from '../../utils/enums'
import { columnTemplates } from '../../utils/templates'
import { fetchAllData, addTab, deleteProfile } from '../../core/core-actions'
import { createProfile, editProfile } from '../../core/core-utils'
import ListViewNested from '../components/list-view-nested'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  const appId = state.core.tabObject.activeApp

  return {
    appId,
    state: state[appId],
    theme: state.core.theme,
    viewTitle: Enums.APP_VIEW_TITLES[appId],
    viewColumns: columnTemplates[appId],
    viewColumnsNested: columnTemplates[appId + '_nested'],
    searchFilter: state[appId].searchFilter
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllData: (appId, callback) => {
      dispatch(fetchAllData(appId, callback))
    },
    addTab: (payload) => {
      dispatch(addTab(payload))
    },
    createProfile: (appId, callback) => {
      createProfile(appId, callback)
    },
    editProfile: (appId, recordId, viewData, callback) => {
      editProfile(appId, recordId, viewData, callback)
    },
    deleteProfile: (appId, activeKey, state, callback) => {
      dispatch(deleteProfile(appId, activeKey, state, callback))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListViewNested)
